import { TFunction } from 'i18next';

import { formatNumberWithUnit } from '~/widgets/earnings/utils/utils';

export const getRecapTitle = (
  t: TFunction,
  fiscalPeriod?: string,
  fiscalYear?: number
) => {
  if (!fiscalPeriod || !fiscalYear) {
    return t('widget:assetOverview.earningsSection.earnings');
  }

  return `${fiscalPeriod} ${fiscalYear} ${t(
    'widget:assetOverview.earningsSection.earnings'
  )}`;
};

export type MetricValueVariant = 'default' | 'positive' | 'negative';

export const getMetricValueColor = (variant: MetricValueVariant) => {
  switch (variant) {
    case 'positive':
      return 'var(--viz-bullish)';
    case 'negative':
      return 'var(--viz-bearish)';
    default:
      return 'var(--text-default)';
  }
};

export const getVariant = (value?: number): MetricValueVariant => {
  if (value === undefined) {
    return 'default';
  }
  return value >= 0 ? 'positive' : 'negative';
};

export interface FormatCurrencyProps {
  value: number | undefined;
  currencySymbol: string;
  showPositiveSign: boolean;
}

export const formatCurrency = ({
  value,
  currencySymbol,
  showPositiveSign,
}: FormatCurrencyProps) => {
  if (value === undefined) {
    return '-';
  }
  const formatted = formatNumberWithUnit(Math.abs(value));
  const sign = value >= 0 ? (showPositiveSign ? '+' : '') : '-';
  return `${sign}${currencySymbol}${formatted}`;
};
